var exports = {
  "u": "NativeDragRegion.module__nativeDragRegion___VUs1dH",
};

module.exports = exports;
